import React, { useState } from 'react'
import { QuestionInputProps, isNumericScale } from '../../questionTypes'

const RATING_LABELS: Record<number, string> = {
  1: 'Poor',
  2: 'Fair',
  3: 'Good',
  4: 'Very Good',
  5: 'Excellent'
}

export const RatingQuestion: React.FC<QuestionInputProps> = ({ question, value, onChange, readOnly = false }) => {
  const [hoveredStar, setHoveredStar] = useState<number | null>(null)
  const activeRating = hoveredStar ?? (value !== '' ? parseInt(value, 10) : 0)

  // Two endpoint labels => numeric 1-5 scale; otherwise stars.
  if (isNumericScale(question.options)) {
    const [minLabel, maxLabel] = question.options
    const selected = value !== '' ? parseInt(value, 10) : 0

    return (
      <div className='survey-response-question__rating'>
        <div className='survey-response-question__scale'>
          {[1, 2, 3, 4, 5].map((n) => (
            <button
              key={n}
              type='button'
              className={['survey-response-question__scale-button', n === selected && 'is-selected']
                .filter(Boolean)
                .join(' ')}
              onClick={() => onChange(String(n))}
              disabled={readOnly}
              aria-label={n === 1 ? `1 - ${minLabel}` : n === 5 ? `5 - ${maxLabel}` : String(n)}
            >
              {n}
            </button>
          ))}
        </div>
        <div className='survey-response-question__scale-labels'>
          <span>{minLabel}</span>
          <span>{maxLabel}</span>
        </div>
      </div>
    )
  }

  return (
    <div className='survey-response-question__rating'>
      <div className='survey-response-question__stars' onMouseLeave={() => setHoveredStar(null)}>
        {[1, 2, 3, 4, 5].map((n) => (
          <button
            key={n}
            type='button'
            className={['survey-response-question__star', n <= activeRating && 'is-filled']
              .filter(Boolean)
              .join(' ')}
            onClick={() => onChange(String(n))}
            onMouseEnter={() => !readOnly && setHoveredStar(n)}
            disabled={readOnly}
            aria-label={`${n} star${n > 1 ? 's' : ''} - ${RATING_LABELS[n]}`}
          >
            <svg viewBox='0 0 24 24' className='survey-response-question__star-svg'>
              <path d='M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z' />
            </svg>
          </button>
        ))}
      </div>
      <div className='survey-response-question__rating-feedback'>
        {activeRating > 0 && (
          <span className={`survey-response-question__rating-label survey-response-question__rating-label--${activeRating}`}>
            {RATING_LABELS[activeRating]}
          </span>
        )}
        {activeRating === 0 && (
          <span className='survey-response-question__rating-hint'>Click a star to rate</span>
        )}
      </div>
    </div>
  )
}
